import { Avatar } from "@mui/material";
import { CustomSVGIcon } from "./bcp/BCPIcons";

export function getInitials(name) {
  if (!name) return "";
  const words = name.trim().split(" ");
  if (words.length === 1) return name.substring(0, 2).toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
}

export function FactionIcon({ icon, name, size = 32, sx, ...rest }) {
  return (
    <Avatar
      alt={name}
      sx={{
        width: size,
        height: size,
        backgroundColor: icon ? "transparent" : undefined,
        fontSize: size * 0.28,
        fontWeight: 700,
        ...sx
      }}
      {...rest}
    >
      {icon ? (
        <CustomSVGIcon src={icon} size={Math.round(size * 0.8)} />
      ) : (
        getInitials(name)
      )}
    </Avatar>
  );
}
